// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"2510b64e","186":"ce134428","272":"fa220708","372":"4ab7f2eb","377":"2295f353","630":"bf8b211a","738":"2da74b1a","841":"695fcfda","851":"dfef5f3a","856":"52370c97"}[chunkId] + ".chunk.js";
};